import React, { useEffect, useState } from 'react'
import { layoutServiceFactory } from './lib/layout-service-factory'
import Layout from './Layout'
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import { Typestyle, Typography } from '@christies/react/foundations'
import { Section } from '@christies/react/components/Atoms'

function NotFound(props) {
  const { sitecoreContext, updateSitecoreContext } = props

  const [routeData, setRouteData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  const layoutServiceInstance = layoutServiceFactory.create()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await layoutServiceInstance.fetchLayoutData('/404errorpage', sitecoreContext.language)
        if (data?.sitecore?.route) {
          setRouteData(data.sitecore.route)
          // Update the sitecoreContext with the new 404 route data
          updateSitecoreContext(data)
        } else {
          setError(true)
        }
      } catch (err) {
        console.error('Error fetching 404 route data:', err)
        setError(true)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [sitecoreContext.language, updateSitecoreContext])

  if (loading) {
    return null
  }

  // The 404 error page also doesn't exist (e.g. something happen in sitecore with 404).
  // TODO: Typestyle.heading404 is temporary and should be replaced with a proper typestyle after we get final design and remove it from DSL.
  if (error || !routeData?.fields) {
    return (
      <Section>
        <Typography as="h1" $textAlign="center" $variant={Typestyle.heading404} $>
          404: We're sorry...
        </Typography>
      </Section>
    )
  }

  return <Layout route={routeData} />
}

export default withSitecoreContext({ updatable: true })(NotFound)
